export interface WalletDetailsResponse {
  value: "Not Implemented";
}

const walletService = {
  getWalletDetails: async (): Promise<any> => {
    console.warn("getWalletSummary not implemented yet");
    return "ok" as any;
  },
};

export default walletService;
